(function(){"use strict";(r=>{try{if(typeof window>"u")return;var e=document.createElement("style");e.appendChild(document.createTextNode(r)),document.head.appendChild(e)}catch(i){console.error("vite-plugin-css-injected-by-js",i)}})(".audio-recorder{background-color:#ebebeb;box-shadow:0 2px 5px #bebebe;border-radius:20px;box-sizing:border-box;color:#000;width:40px;display:flex;align-items:center;transition:all .2s ease-in;-webkit-tap-highlight-color:transparent}.audio-recorder-mic{box-sizing:content-box;cursor:pointer;height:16px;color:#000;padding:12px}.audio-recorder .audio-recorder-mic{border-radius:20px}.audio-recorder.recording .audio-recorder-mic{border-radius:0}.audio-recorder-timer,.audio-recorder-status{color:#000;margin-left:10px;font-family:Segoe UI,Tahoma,Geneva,Verdana,sans-serif;font-size:14px;font-weight:400;line-height:1}.audio-recorder-status{margin-left:15px;display:flex;align-items:baseline;flex-grow:1;animation-name:fading-ar-status;animation-duration:2s;animation-iteration-count:infinite}.audio-recorder-status-dot{background-color:#d00;border-radius:50%;height:10px;width:9px;margin-right:5px}.audio-recorder-options{box-sizing:content-box;height:16px;cursor:pointer;padding:12px 6px 12px 12px}.audio-recorder-options~.audio-recorder-options{padding:12px 12px 12px 6px;border-radius:0 5px 5px 0}.recording{border-radius:12px;width:300px;transition:all .2s ease-out}.display-none{display:none}.audio-recorder-visualizer{margin-left:15px;flex-grow:1;align-self:center;display:flex;align-items:center}@keyframes fading-ar-status{0%{opacity:1}50%{opacity:0}to{opacity:1}}")})();
import ge, { useState as B, useCallback as J, useEffect as cr, Suspense as lr } from "react";
var de = { exports: {} }, H = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ke;
function fr() {
  if (ke)
    return H;
  ke = 1;
  var D = ge, j = Symbol.for("react.element"), z = Symbol.for("react.fragment"), E = Object.prototype.hasOwnProperty, I = D.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, C = { key: !0, ref: !0, __self: !0, __source: !0 };
  function y(T, i, c) {
    var d, v = {}, M = null, m = null;
    c !== void 0 && (M = "" + c), i.key !== void 0 && (M = "" + i.key), i.ref !== void 0 && (m = i.ref);
    for (d in i)
      E.call(i, d) && !C.hasOwnProperty(d) && (v[d] = i[d]);
    if (T && T.defaultProps)
      for (d in i = T.defaultProps, i)
        v[d] === void 0 && (v[d] = i[d]);
    return { $$typeof: j, type: T, key: M, ref: m, props: v, _owner: I.current };
  }
  return H.Fragment = z, H.jsx = y, H.jsxs = y, H;
}
var $ = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _e;
function dr() {
  return _e || (_e = 1, process.env.NODE_ENV !== "production" && function() {
    var D = ge, j = Symbol.for("react.element"), z = Symbol.for("react.portal"), E = Symbol.for("react.fragment"), I = Symbol.for("react.strict_mode"), C = Symbol.for("react.profiler"), y = Symbol.for("react.provider"), T = Symbol.for("react.context"), i = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), _ = Symbol.iterator, A = "@@iterator";
    function O(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = _ && e[_] || e[A];
      return typeof r == "function" ? r : null;
    }
    var h = D.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          t[a - 1] = arguments[a];
        V("error", e, t);
      }
    }
    function V(e, r, t) {
      {
        var a = h.ReactDebugCurrentFrame, u = a.getStackAddendum();
        u !== "" && (r += "%s", t = t.concat([u]));
        var s = t.map(function(o) {
          return String(o);
        });
        s.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, s);
      }
    }
    var p = !1, R = !1, x = !1, Q = !1, P = !1, Y;
    Y = Symbol.for("react.module.reference");
    function L(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === E || e === C || P || e === I || e === c || e === d || Q || e === m || p || R || x || typeof e == "object" && e !== null && (e.$$typeof === M || e.$$typeof === v || e.$$typeof === y || e.$$typeof === T || e.$$typeof === i || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === Y || e.getModuleId !== void 0));
    }
    function te(e, r, t) {
      var a = e.displayName;
      if (a)
        return a;
      var u = r.displayName || r.name || "";
      return u !== "" ? t + "(" + u + ")" : t;
    }
    function ae(e) {
      return e.displayName || "Context";
    }
    function S(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case E:
          return "Fragment";
        case z:
          return "Portal";
        case C:
          return "Profiler";
        case I:
          return "StrictMode";
        case c:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case T:
            var r = e;
            return ae(r) + ".Consumer";
          case y:
            var t = e;
            return ae(t._context) + ".Provider";
          case i:
            return te(e, e.render, "ForwardRef");
          case v:
            var a = e.displayName || null;
            return a !== null ? a : S(e.type) || "Memo";
          case M: {
            var u = e, s = u._payload, o = u._init;
            try {
              return S(o(s));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, U = 0, ve, Me, me, we, ye, je, Ce;
    function pe() {
    }
    pe.__reactDisabledLog = !0;
    function Pe() {
      {
        if (U === 0) {
          ve = console.log, Me = console.info, me = console.warn, we = console.error, ye = console.group, je = console.groupCollapsed, Ce = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: pe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        U++;
      }
    }
    function Ye() {
      {
        if (U--, U === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, e, {
              value: ve
            }),
            info: W({}, e, {
              value: Me
            }),
            warn: W({}, e, {
              value: me
            }),
            error: W({}, e, {
              value: we
            }),
            group: W({}, e, {
              value: ye
            }),
            groupCollapsed: W({}, e, {
              value: je
            }),
            groupEnd: W({}, e, {
              value: Ce
            })
          });
        }
        U < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ie = h.ReactCurrentDispatcher, ne;
    function X(e, r, t) {
      {
        if (ne === void 0)
          try {
            throw Error();
          } catch (u) {
            var a = u.stack.trim().match(/\n( *(at )?)/);
            ne = a && a[1] || "";
          }
        return `
` + ne + e;
      }
    }
    var oe = !1, K;
    {
      var We = typeof WeakMap == "function" ? WeakMap : Map;
      K = new We();
    }
    function be(e, r) {
      if (!e || oe)
        return "";
      {
        var t = K.get(e);
        if (t !== void 0)
          return t;
      }
      var a;
      oe = !0;
      var u = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var s;
      s = ie.current, ie.current = null, Pe();
      try {
        if (r) {
          var o = function() {
            throw Error();
          };
          if (Object.defineProperty(o.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o, []);
            } catch (k) {
              a = k;
            }
            Reflect.construct(e, [], o);
          } else {
            try {
              o.call();
            } catch (k) {
              a = k;
            }
            e.call(o.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (k) {
            a = k;
          }
          e();
        }
      } catch (k) {
        if (k && a && typeof k.stack == "string") {
          for (var n = k.stack.split(`
`), w = a.stack.split(`
`), l = n.length - 1, f = w.length - 1; l >= 1 && f >= 0 && n[l] !== w[f]; )
            f--;
          for (; l >= 1 && f >= 0; l--, f--)
            if (n[l] !== w[f]) {
              if (l !== 1 || f !== 1)
                do
                  if (l--, f--, f < 0 || n[l] !== w[f]) {
                    var b = `
` + n[l].replace(" at new ", " at ");
                    return e.displayName && b.includes("<anonymous>") && (b = b.replace("<anonymous>", e.displayName)), typeof e == "function" && K.set(e, b), b;
                  }
                while (l >= 1 && f >= 0);
              break;
            }
        }
      } finally {
        oe = !1, ie.current = s, Ye(), Error.prepareStackTrace = u;
      }
      var F = e ? e.displayName || e.name : "", Oe = F ? X(F) : "";
      return typeof e == "function" && K.set(e, Oe), Oe;
    }
    function Be(e, r, t) {
      return be(e, !1);
    }
    function Ve(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function q(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return be(e, Ve(e));
      if (typeof e == "string")
        return X(e);
      switch (e) {
        case c:
          return X("Suspense");
        case d:
          return X("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case i:
            return Be(e.render);
          case v:
            return q(e.type, r, t);
          case M: {
            var a = e, u = a._payload, s = a._init;
            try {
              return q(s(u), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var ee = Object.prototype.hasOwnProperty, Ne = {}, Ie = h.ReactDebugCurrentFrame;
    function re(e) {
      if (e) {
        var r = e._owner, t = q(e.type, e._source, r ? r.type : null);
        Ie.setExtraStackFrame(t);
      } else
        Ie.setExtraStackFrame(null);
    }
    function Qe(e, r, t, a, u) {
      {
        var s = Function.call.bind(ee);
        for (var o in e)
          if (s(e, o)) {
            var n = void 0;
            try {
              if (typeof e[o] != "function") {
                var w = Error((a || "React class") + ": " + t + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw w.name = "Invariant Violation", w;
              }
              n = e[o](r, o, a, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (l) {
              n = l;
            }
            n && !(n instanceof Error) && (re(u), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", a || "React class", t, o, typeof n), re(null)), n instanceof Error && !(n.message in Ne) && (Ne[n.message] = !0, re(u), g("Failed %s type: %s", t, n.message), re(null));
          }
      }
    }
    var Ze = Array.isArray;
    function ue(e) {
      return Ze(e);
    }
    function Fe(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Ue(e) {
      try {
        return Te(e), !1;
      } catch {
        return !0;
      }
    }
    function Te(e) {
      return "" + e;
    }
    function Le(e) {
      if (Ue(e))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Fe(e)), Te(e);
    }
    var G = h.ReactCurrentOwner, Ge = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Se, De, se;
    se = {};
    function Je(e) {
      if (ee.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function He(e) {
      if (ee.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function $e(e, r) {
      if (typeof e.ref == "string" && G.current && r && G.current.stateNode !== r) {
        var t = S(G.current.type);
        se[t] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', S(G.current.type), e.ref), se[t] = !0);
      }
    }
    function Xe(e, r) {
      {
        var t = function() {
          Se || (Se = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function Ke(e, r) {
      {
        var t = function() {
          De || (De = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var qe = function(e, r, t, a, u, s, o) {
      var n = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: j,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: o,
        // Record the component responsible for creating this element.
        _owner: s
      };
      return n._store = {}, Object.defineProperty(n._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(n, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(n, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: u
      }), Object.freeze && (Object.freeze(n.props), Object.freeze(n)), n;
    };
    function er(e, r, t, a, u) {
      {
        var s, o = {}, n = null, w = null;
        t !== void 0 && (Le(t), n = "" + t), He(r) && (Le(r.key), n = "" + r.key), Je(r) && (w = r.ref, $e(r, u));
        for (s in r)
          ee.call(r, s) && !Ge.hasOwnProperty(s) && (o[s] = r[s]);
        if (e && e.defaultProps) {
          var l = e.defaultProps;
          for (s in l)
            o[s] === void 0 && (o[s] = l[s]);
        }
        if (n || w) {
          var f = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          n && Xe(o, f), w && Ke(o, f);
        }
        return qe(e, n, w, u, a, G.current, o);
      }
    }
    var ce = h.ReactCurrentOwner, Ee = h.ReactDebugCurrentFrame;
    function Z(e) {
      if (e) {
        var r = e._owner, t = q(e.type, e._source, r ? r.type : null);
        Ee.setExtraStackFrame(t);
      } else
        Ee.setExtraStackFrame(null);
    }
    var le;
    le = !1;
    function fe(e) {
      return typeof e == "object" && e !== null && e.$$typeof === j;
    }
    function he() {
      {
        if (ce.current) {
          var e = S(ce.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function rr(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t = e.lineNumber;
          return `

Check your code at ` + r + ":" + t + ".";
        }
        return "";
      }
    }
    var Re = {};
    function tr(e) {
      {
        var r = he();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function xe(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = tr(r);
        if (Re[t])
          return;
        Re[t] = !0;
        var a = "";
        e && e._owner && e._owner !== ce.current && (a = " It was passed a child from " + S(e._owner.type) + "."), Z(e), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, a), Z(null);
      }
    }
    function ze(e, r) {
      {
        if (typeof e != "object")
          return;
        if (ue(e))
          for (var t = 0; t < e.length; t++) {
            var a = e[t];
            fe(a) && xe(a, r);
          }
        else if (fe(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var u = O(e);
          if (typeof u == "function" && u !== e.entries)
            for (var s = u.call(e), o; !(o = s.next()).done; )
              fe(o.value) && xe(o.value, r);
        }
      }
    }
    function ar(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === i || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === v))
          t = r.propTypes;
        else
          return;
        if (t) {
          var a = S(r);
          Qe(t, e.props, "prop", a, e);
        } else if (r.PropTypes !== void 0 && !le) {
          le = !0;
          var u = S(r);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", u || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ir(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var a = r[t];
          if (a !== "children" && a !== "key") {
            Z(e), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a), Z(null);
            break;
          }
        }
        e.ref !== null && (Z(e), g("Invalid attribute `ref` supplied to `React.Fragment`."), Z(null));
      }
    }
    function Ae(e, r, t, a, u, s) {
      {
        var o = L(e);
        if (!o) {
          var n = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (n += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var w = rr(u);
          w ? n += w : n += he();
          var l;
          e === null ? l = "null" : ue(e) ? l = "array" : e !== void 0 && e.$$typeof === j ? (l = "<" + (S(e.type) || "Unknown") + " />", n = " Did you accidentally export a JSX literal instead of a component?") : l = typeof e, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", l, n);
        }
        var f = er(e, r, t, u, s);
        if (f == null)
          return f;
        if (o) {
          var b = r.children;
          if (b !== void 0)
            if (a)
              if (ue(b)) {
                for (var F = 0; F < b.length; F++)
                  ze(b[F], e);
                Object.freeze && Object.freeze(b);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ze(b, e);
        }
        return e === E ? ir(f) : ar(f), f;
      }
    }
    function nr(e, r, t) {
      return Ae(e, r, t, !0);
    }
    function or(e, r, t) {
      return Ae(e, r, t, !1);
    }
    var ur = or, sr = nr;
    $.Fragment = E, $.jsx = ur, $.jsxs = sr;
  }()), $;
}
process.env.NODE_ENV === "production" ? de.exports = fr() : de.exports = dr();
var N = de.exports;
const gr = (D, j, z) => {
  const [E, I] = B(!1), [C, y] = B(!1), [T, i] = B(0), [c, d] = B(), [v, M] = B(), [m, _] = B(), A = J(() => {
    const p = setInterval(() => {
      i((R) => R + 1);
    }, 1e3);
    M(p);
  }, [i, M]), O = J(() => {
    v != null && clearInterval(v), M(void 0);
  }, [v, M]), h = J(() => {
    v == null && navigator.mediaDevices.getUserMedia({ audio: D ?? !0 }).then((p) => {
      I(!0);
      const R = new MediaRecorder(
        p,
        z
      );
      d(R), R.start(), A(), R.addEventListener("dataavailable", (x) => {
        _(x.data), R.stream.getTracks().forEach((Q) => Q.stop()), d(void 0);
      });
    }).catch((p) => {
      console.log(p.name, p.message, p.cause), j == null || j(p);
    });
  }, [
    v,
    I,
    d,
    A,
    _,
    j,
    z
  ]), g = J(() => {
    c == null || c.stop(), O(), i(0), I(!1), y(!1);
  }, [
    c,
    i,
    I,
    y,
    O
  ]), V = J(() => {
    C ? (y(!1), c == null || c.resume(), A()) : (y(!0), O(), c == null || c.pause());
  }, [c, y, A, O]);
  return {
    startRecording: h,
    stopRecording: g,
    togglePauseResume: V,
    recordingBlob: m,
    isRecording: E,
    isPaused: C,
    recordingTime: T,
    mediaRecorder: c
  };
}, vr = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDQ3MCA0NzAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ3MCA0NzA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KCTxnPgoJCTxwYXRoIGQ9Ik0yMzUsMzAyLjI5NmM0Ny4xNzcsMCw4NS40MjMtMzguMjQ1LDg1LjQyMy04NS40MjNWODUuNDIzQzMyMC40MjMsMzguMjQ1LDI4Mi4xNzcsMCwyMzUsMHMtODUuNDIzLDM4LjI0NS04NS40MjMsODUuNDIzCgkJCXYxMzEuNDUxQzE0OS41NzcsMjY0LjA1MSwxODcuODIzLDMwMi4yOTYsMjM1LDMwMi4yOTZ6Ii8+CgkJPHBhdGggZD0iTTM1MC40MjMsMTM2LjE0OHYzMGgxNXY1MC43MjZjMCw3MS45MTUtNTguNTA4LDEzMC40MjMtMTMwLjQyMywxMzAuNDIzcy0xMzAuNDIzLTU4LjUwNy0xMzAuNDIzLTEzMC40MjN2LTUwLjcyNmgxNXYtMzAKCQkJaC00NXY4MC43MjZDNzQuNTc3LDMwMC4yNzMsMTM4LjU1MSwzNjksMjIwLDM3Ni41ODlWNDQwaC05MC40NDR2MzBoMjEwLjg4OXYtMzBIMjUwdi02My40MTEKCQkJYzgxLjQ0OS03LjU4OSwxNDUuNDIzLTc2LjMxNywxNDUuNDIzLTE1OS43MTZ2LTgwLjcyNkgzNTAuNDIzeiIvPgoJPC9nPgo8L3N2Zz4K", Mr = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNDcuNjA3IDQ3LjYwNyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDcuNjA3IDQ3LjYwNzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgoJPGc+CgkJPHBhdGggZD0iTTE3Ljk5MSw0MC45NzZjMCwzLjY2Mi0yLjk2OSw2LjYzMS02LjYzMSw2LjYzMWwwLDBjLTMuNjYyLDAtNi42MzEtMi45NjktNi42MzEtNi42MzFWNi42MzFDNC43MjksMi45NjksNy42OTgsMCwxMS4zNiwwCgkJCWwwLDBjMy42NjIsMCw2LjYzMSwyLjk2OSw2LjYzMSw2LjYzMVY0MC45NzZ6Ii8+CgkJPHBhdGggZD0iTTQyLjg3Nyw0MC45NzZjMCwzLjY2Mi0yLjk2OSw2LjYzMS02LjYzMSw2LjYzMWwwLDBjLTMuNjYyLDAtNi42MzEtMi45NjktNi42MzEtNi42MzFWNi42MzEKCQkJQzI5LjYxNiwyLjk2OSwzMi41ODUsMCwzNi4yNDYsMGwwLDBjMy42NjIsMCw2LjYzMSwyLjk2OSw2LjYzMSw2LjYzMVY0MC45NzZ6Ii8+Cgk8L2c+Cjwvc3ZnPgo=", mr = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDQ5NC4xNDggNDk0LjE0OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDk0LjE0OCA0OTQuMTQ4OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cgk8Zz4KCQk8Zz4KCQkJPHBhdGggZD0iTTQwNS4yODQsMjAxLjE4OEwxMzAuODA0LDEzLjI4QzExOC4xMjgsNC41OTYsMTA1LjM1NiwwLDk0Ljc0LDBDNzQuMjE2LDAsNjEuNTIsMTYuNDcyLDYxLjUyLDQ0LjA0NHY0MDYuMTI0CgkJCQljMCwyNy41NCwxMi42OCw0My45OCwzMy4xNTYsNDMuOThjMTAuNjMyLDAsMjMuMi00LjYsMzUuOTA0LTEzLjMwOGwyNzQuNjA4LTE4Ny45MDRjMTcuNjYtMTIuMTA0LDI3LjQ0LTI4LjM5MiwyNy40NC00NS44ODQKCQkJCUM0MzIuNjMyLDIyOS41NzIsNDIyLjk2NCwyMTMuMjg4LDQwNS4yODQsMjAxLjE4OHoiLz4KCQk8L2c+Cgk8L2c+Cjwvc3ZnPgo=", wr = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTggMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbD0iIzAwMDAwMCIgZD0iTTE3Ljg1IDMuMTVsLTIuOTktM0EuNTA4LjUwOCAwIDAgMCAxNC41IDBIMS40QTEuNDE3IDEuNDE3IDAgMCAwIDAgMS40M3YxNS4xNEExLjQxNyAxLjQxNyAwIDAgMCAxLjQgMThoMTUuMmExLjQxNyAxLjQxNyAwIDAgMCAxLjQtMS40M1YzLjVhLjQ3LjQ3IDAgMCAwLS4xNS0uMzV6TTIgNVYzYTEgMSAwIDAgMSAxLTFoOGExIDEgMCAwIDEgMSAxdjJhMSAxIDAgMCAxLTEgMUgzYTEgMSAwIDAgMS0xLTF6bTcgMTFhNCA0IDAgMSAxIDQtNCA0IDQgMCAwIDEtNCA0eiIvPgo8L3N2Zz4K", yr = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNDYuNzM0IDQ2LjczNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDYuNzM0IDQ2LjczNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik00MS4zNDYsMEg1LjM4OEMyLjQxNywwLDAsMi40MTcsMCw1LjM4OHYzNS45NThjMCwyLjk3MSwyLjQxNyw1LjM4OCw1LjM4OCw1LjM4OGgzNS45NThjMi45NzEsMCw1LjM4OC0yLjQxNyw1LjM4OC01LjM4OAoJCVY1LjM4OEM0Ni43MzMsMi40MTcsNDQuMzE2LDAsNDEuMzQ2LDB6Ii8+CjwvZz4KPC9zdmc+Cg==";
const jr = ge.lazy(async () => {
  const { LiveAudioVisualizer: D } = await import("./react-audio-visualize.es-69216c73.js");
  return { default: D };
}), pr = ({
  onRecordingComplete: D,
  onNotAllowedOrFound: j,
  recorderControls: z,
  audioTrackConstraints: E,
  downloadOnSavePress: I = !1,
  downloadFileExtension: C = "webm",
  showVisualizer: y = !1,
  mediaRecorderOptions: T,
  classes: i
}) => {
  const {
    startRecording: c,
    stopRecording: d,
    togglePauseResume: v,
    recordingBlob: M,
    isRecording: m,
    isPaused: _,
    recordingTime: A,
    mediaRecorder: O
  } = z ?? // eslint-disable-next-line react-hooks/rules-of-hooks
  gr(
    E,
    j,
    T
  ), [h, g] = B(!1), V = (x = !0) => {
    g(x), d();
  }, p = async (x) => {
    const P = (await import("./index-1c988149.js").then((S) => S.i)).createFFmpeg({ log: !1 });
    await P.load();
    const Y = "input.webm", L = `output.${C}`;
    P.FS(
      "writeFile",
      Y,
      new Uint8Array(await x.arrayBuffer())
    ), await P.run("-i", Y, L);
    const te = P.FS("readFile", L);
    return new Blob([te.buffer], {
      type: `audio/${C}`
    });
  }, R = async (x) => {
    !crossOriginIsolated && C !== "webm" && console.warn(
      'This website is not "cross-origin isolated". Audio will be downloaded in webm format, since mp3/wav encoding requires cross origin isolation. Please visit https://web.dev/cross-origin-isolation-guide/ and https://web.dev/coop-coep/ for information on how to make your website "cross-origin isolated"'
    );
    const Q = crossOriginIsolated ? await p(x) : x, P = crossOriginIsolated ? C : "webm", Y = URL.createObjectURL(Q), L = document.createElement("a");
    L.style.display = "none", L.href = Y, L.download = `audio.${P}`, document.body.appendChild(L), L.click(), L.remove();
  };
  return cr(() => {
    (h || z) && M != null && D != null && (D(M), I && R(M));
  }, [M]), /* @__PURE__ */ N.jsxs(
    "div",
    {
      className: `audio-recorder ${m ? "recording" : ""} ${(i == null ? void 0 : i.AudioRecorderClass) ?? ""}`,
      "data-testid": "audio_recorder",
      children: [
        /* @__PURE__ */ N.jsx(
          "img",
          {
            src: m ? wr : vr,
            className: `audio-recorder-mic ${(i == null ? void 0 : i.AudioRecorderStartSaveClass) ?? ""}`,
            onClick: m ? () => V() : c,
            "data-testid": "ar_mic",
            title: m ? "Save recording" : "Start recording"
          }
        ),
        /* @__PURE__ */ N.jsxs(
          "span",
          {
            className: `audio-recorder-timer ${m ? "" : "display-none"} ${(i == null ? void 0 : i.AudioRecorderTimerClass) ?? ""}`,
            "data-testid": "ar_timer",
            children: [
              Math.floor(A / 60),
              ":",
              String(A % 60).padStart(2, "0")
            ]
          }
        ),
        y ? /* @__PURE__ */ N.jsx(
          "span",
          {
            className: `audio-recorder-visualizer ${m ? "" : "display-none"}`,
            children: O && /* @__PURE__ */ N.jsx(lr, { fallback: /* @__PURE__ */ N.jsx(N.Fragment, {}), children: /* @__PURE__ */ N.jsx(
              jr,
              {
                mediaRecorder: O,
                barWidth: 2,
                gap: 2,
                width: 140,
                height: 30,
                fftSize: 512,
                maxDecibels: -10,
                minDecibels: -80,
                smoothingTimeConstant: 0.4
              }
            ) })
          }
        ) : /* @__PURE__ */ N.jsxs(
          "span",
          {
            className: `audio-recorder-status ${m ? "" : "display-none"} ${(i == null ? void 0 : i.AudioRecorderStatusClass) ?? ""}`,
            children: [
              /* @__PURE__ */ N.jsx("span", { className: "audio-recorder-status-dot" }),
              "Recording"
            ]
          }
        ),
        /* @__PURE__ */ N.jsx(
          "img",
          {
            src: _ ? mr : Mr,
            className: `audio-recorder-options ${m ? "" : "display-none"} ${(i == null ? void 0 : i.AudioRecorderPauseResumeClass) ?? ""}`,
            onClick: v,
            title: _ ? "Resume recording" : "Pause recording",
            "data-testid": "ar_pause"
          }
        ),
        /* @__PURE__ */ N.jsx(
          "img",
          {
            src: yr,
            className: `audio-recorder-options ${m ? "" : "display-none"} ${(i == null ? void 0 : i.AudioRecorderDiscardClass) ?? ""}`,
            onClick: () => V(!1),
            title: "Discard Recording",
            "data-testid": "ar_cancel"
          }
        )
      ]
    }
  );
};
export {
  pr as AudioRecorder,
  gr as useAudioRecorder
};
